import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { faScheduleappointmenClose } from '../../constants';

@Component({
  selector: 'app-schedule-appointment-action',
  imports: [FontAwesomeModule, MatButtonModule, MatDialogModule],
  templateUrl: './schedule-appointment-action.component.html',
  styleUrls: ['./schedule-appointment-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleAppointmentActionComponent {
  protected faClose = faScheduleappointmenClose;
}
